import { useEffect, useMemo } from "react";
import { Tender } from "../../tender_page/tender.module";

export function useDefaultProvisionType(
	setFieldValue: (fieldName: string, value: any) => void, tender?: Tender
): void {
	const defaultProvisionType = useMemo((() => {
		if (tender) {
			return tender?.sites?.[0]?.default_provision_type;
		}
		return null;
	}), [tender]);

	useEffect(() => {
		setFieldValue(
			"provisionType",
			defaultProvisionType
		);
	}, [defaultProvisionType]);	
}
